import { render } from "./NewCustomerForm.vue?vue&type=template&id=3ddf6036&ts=true"
import script from "./NewCustomerForm.vue?vue&type=script&lang=ts"
export * from "./NewCustomerForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__